/** Strings owned by the content components (C5). */
const list = (items: readonly string[]) =>
  items.length <= 1
    ? items.join('')
    : `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`

export const contentCopy = {
  combobox: { retry: 'Retry' },
  chip: { remove: (label: string) => `Remove ${label}` },
  searchInput: {
    clear: 'Clear filter',
    count: (shown: number, total?: number, noun?: string) =>
      [
        total == null
          ? `${shown.toLocaleString()}`
          : `${shown.toLocaleString()} of ${total.toLocaleString()}`,
        noun,
      ]
        .filter(Boolean)
        .join(' '),
  },
  avatarGroup: {
    label: (names: readonly string[], others: number) =>
      list(
        others > 0
          ? [...names, `${others} ${others === 1 ? 'other' : 'others'}`]
          : names,
      ),
  },
} as const
